<template>
  <div style="display: flex; align-items: center; width: 100%">
    <label>{{title}}</label>
    <el-select v-model="typeId" placeholder="Select" class="select-item" style="width: 100%; flex: 1" @change="typeChange" filterable>
      <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id">
      </el-option>
    </el-select>
    <el-select v-model="subTypeId" placeholder="Select" class="select-item" style="width: 100%; flex: 1; margin-left: 8px" @change="subTypeChange" filterable>
      <el-option v-for="item in subTypeList" :key="item.id" :label="item.name" :value="item.id">
      </el-option>
    </el-select>
  </div>
</template>

<script>
import {getFormData} from "@/api/api";
import {listAllCommodityType} from "@/api/url";

export default {
name: "commodityTypeList",
  props: {
    title: {
      type: String,
      default: '商品分类',
    },
    reSet: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      typeList: [
        {name: '不限', id: 0}
      ],
      typeId: 0,
      subTypeList: [
        {name: '不限', id: 0}
      ],
      subTypeId: 0
    }
  },
  watch: {
    reSet() {
      if(this.reSet) {
        this.typeId = 0
        this.subTypeId = 0
        this.$emit('confirm', [this.typeId, this.subTypeId, false])
      }
    }
  },
  methods: {
    getCommodityTypeList() {
      getFormData(listAllCommodityType).then(data=> {
        this.typeList = this.typeList.concat(data.data)
        this.typeList.map(item => {
          if(item.subTypeList && item.subTypeList.length > 0) {
            this.subTypeList = this.subTypeList.concat(item.subTypeList)
          }
        })
      })
    },

    typeChange() {
      this.subTypeId = 0
      this.subTypeList = [
        {name: '不限', id: 0}
      ]
      if(this.typeId == 0) {
        this.typeList.map(item => {
          if(item.subTypeList && item.subTypeList.length > 0) {
            this.subTypeList = this.subTypeList.concat(item.subTypeList)
          }
        })
      }else {
        for(let i=0; i<this.typeList.length; i++) {
          if(this.typeId == this.typeList[i].id) {
            this.subTypeList = this.subTypeList.concat(this.typeList[i].subTypeList)
          }
        }
      }
      this.$emit('confirm', [this.typeId, this.subTypeId])
    },

    subTypeChange() {
      this.$emit('confirm', [this.typeId, this.subTypeId])
    }

  },
  mounted() {
    this.getCommodityTypeList()
  }
}
</script>

<style scoped>

</style>
